import { useEffect, useState } from 'react';

import {
	agencyLifetime,
	agencyYearly,
	upsellProducts,
} from '../../../utils/UpsellProducts';
import { AGENCY_BUNDLE_ID } from '../../../utils/AgencyBundleProducts';

export function UpsellCard(props) {
	const {
		index,
		addToCartUpsell,
		cartData,
		coupon,
		licenseKey,
		setLicenseKey,
		cartLoading,
	} = props;

	const [checked, setChecked] = useState({
		downloadId: '',
		priceId: '',
	});
	const [removeLicenseKey, setRemoveLicenseKey] = useState(false);
	const [upsells, setUpsells] = useState(undefined);
	const getOldCart = () => {
		const oldCart = localStorage.getItem('old_cart');
		if (oldCart && oldCart.length) {
			return JSON.parse(oldCart);
		}
		return null;
	};
	useEffect(() => {
		if (cartData && cartData.details && cartData.details.length) {
			if (cartData.details.length >= 1 && !upsells) {
				let product = cartData.details[0];
				setChecked({
					downloadId: parseInt(product.id),
					priceId: parseInt(product?.item_number?.options?.price_id),
				});
				const oldCart = getOldCart();
				if (oldCart) {
					product = oldCart.items[0];
				}

				const [filtered] = upsellProducts.filter(
					each =>
						each.downloadId === parseInt(product.id) ||
						each.downloadId === parseInt(product.download_id)
				);

				if (filtered && filtered.upsells.length) {
					const [filteredUpsells] = filtered.upsells.filter(each => {
						return (
							each.priceId ===
								parseInt(
									product?.item_number?.options?.price_id
								) ||
							each.priceId === parseInt(product?.price_id)
						);
					});
					filteredUpsells &&
						filteredUpsells.products.length &&
						setUpsells(filteredUpsells.products);
				}
			} else {
				if (!upsells) {
					setUpsells([agencyYearly, agencyLifetime]);
				}
			}
		}
	}, [cartData]);

	useEffect(() => {
		if (cartLoading && licenseKey.length) {
			setRemoveLicenseKey(true);
		} else {
			if (removeLicenseKey) {
				setLicenseKey('');
			}
		}
	}, [cartLoading]);

	const handleChange = (e, upsellProduct) => {
		if (e.target.checked) {
			setChecked({
				downloadId: upsellProduct.downloadId,
				priceId: upsellProduct.priceId,
			});
			let oldCart = getOldCart();
			if (!oldCart) {
				oldCart = {};
				oldCart.items = cartData.details.map((item, index) => {
					return {
						download_id: item.id,
						price_id: item.item_number?.options?.price_id,
					};
				});
				if (coupon && coupon.code) {
					oldCart.coupon = coupon.code;
				}
				if (licenseKey) {
					oldCart.licenseKey = licenseKey;
				}
				localStorage.setItem('old_cart', JSON.stringify(oldCart));
			}
			addToCartUpsell(
				[
					{
						download_id: upsellProduct.downloadId,
						price_id: upsellProduct.priceId,
					},
				],
				upsellProduct.coupon
			);
		} else {
			setChecked({
				downloadId: '',
				priceId: '',
			});
			const oldCartData = localStorage.getItem('old_cart');
			if (oldCartData && oldCartData.length) {
				const cart = JSON.parse(oldCartData);
				if (cart.coupon) {
					addToCartUpsell(cart.items, cart.coupon);
				} else {
					addToCartUpsell(cart.items);
				}

				if (cart.licenseKey) {
					setLicenseKey(cart.licenseKey);
				}

				localStorage.removeItem('old_cart');
			}
		}
	};

	const isAgencyLifetime = item =>
		item.downloadId === AGENCY_BUNDLE_ID && item.priceId >= 2;

	const isChecked = upsellItem => {
		if (
			isAgencyLifetime(checked) &&
			checked.downloadId === upsellItem.downloadId &&
			checked.priceId === upsellItem.priceId
		) {
			return true;
		}

		// OLD LOGIC
		return (
			checked &&
			checked.priceId === upsellItem.priceId &&
			checked.downloadId === upsellItem.downloadId
		);
	};

	if (!(upsells && !cartLoading)) {
		return null;
	}

	return (
		<>
			<form>
				{upsells.map(upsellItem => {
					return (
						<label
							key={`addToItem-${upsellItem.downloadId}-${upsellItem.priceId}`}
							htmlFor={`addToItem-${upsellItem.downloadId}-${upsellItem.priceId}`}
							className="wp-checkout-agencyBundleCard"
						>
							<div className="wp-checkout-flex  wp-checkout-agencyBundleCard-wrapper">
								<div className="wp-checkout-agencyBundleCard-add">
									<input
										type="checkbox"
										id={`addToItem-${upsellItem.downloadId}-${upsellItem.priceId}`}
										className="wp-checkout-checkbox-input"
										onChange={e =>
											handleChange(e, upsellItem)
										}
										checked={isChecked(upsellItem)}
									/>
									<label
										htmlFor={`addToItem-${upsellItem.downloadId}-${upsellItem.priceId}`}
										className="wp-checkout-checkbox-label agencyBundleCard-add-checkbox"
									></label>
								</div>

								<div className="wp-checkout-agencyBundleCard-header">
									<div className="wp-checkout-flex wp-checkout-flex-center agencyBundleCard-header-content">
										<h3 className="wp-checkout-font-lg agencyBundleCard-header">
											{upsellItem.name}
										</h3>
										{upsellItem.lifetime && (
											<span className="wp-checkout-font-sm wp-checkout-agencyBundleCard-tag">
												Lifetime
											</span>
										)}
									</div>
									<p
										className="wp-checkout-font-sm agencyBundleCard-sub-header"
										dangerouslySetInnerHTML={{
											__html: upsellItem.details(
												isChecked(upsellItem)
													? 0
													: cartData?.total,
												cartData
											),
										}}
									></p>
									{/* <p className="wp-checkout-font-sm agencyBundleCard-sub-header">
										Unlock Agency Bundle Yearly License & get access
										to 10+ Premium Products for only{' '}
										<span className="card-price-highlight">
											$361.52 more.
										</span>
									</p> */}
								</div>

								{upsellItem?.savedValue && (
									<div className="wp-checkout-agencyBundleCard-price-tag">
										<span>
											${upsellItem.savedValue} Value
										</span>
									</div>
								)}
							</div>
						</label>
					);
				})}

				{/* <label className="wp-checkout-agencyBundleCard wp-checkout-agencyBundleCard-multiple-bg-color">
					<div className="wp-checkout-agencyBundleCard-multiple-bg-color-wrapper">
						<div className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-flex-center wp-checkout-agencyBundleCard-wrapper">
							<div className="wp-checkout-flex">
								<div className="wp-checkout-agencyBundleCard-add">
									<input
										type="checkbox"
										id="addToItem-{upsellItem.downloadId}-{upsellItem.priceId}"
										className="wp-checkout-checkbox-input"
									/>
									<label
										htmlFor="addToItem-{upsellItem.downloadId}-{upsellItem.priceId}"
										className="wp-checkout-checkbox-label agencyBundleCard-add-checkbox"
									></label>
								</div>

								<div className="wp-checkout-agencyBundleCard-header">
									<div className="wp-checkout-flex wp-checkout-flex-center agencyBundleCard-header-content">
										<h3 className="wp-checkout-font-lg agencyBundleCard-header">
											Agency Bundle
										</h3>
										<span className="wp-checkout-font-sm wp-checkout-agencyBundleCard-tag">
											Lifetime
										</span>
									</div>
									<p className="wp-checkout-font-sm agencyBundleCard-sub-header">
										Unlock Agency Bundle lifetime only
										<span className="card-price-highlight">
											$361.52
										</span>
									</p>
								</div>
							</div>

							<div className="wp-checkout-agencyBundleCard-price-tag">
								<span>$2600 Value</span>
							</div>
						</div>
					</div>
				</label> */}
			</form>
		</>
	);
}
